module.exports = __webpack_public_path__ + "img/pay-icon-1.7d9f0422.png";